import * as React from 'react'
import * as cn from 'classnames'
import * as cardStyles from '../Card.module.scss'
import * as styles from './PlayButtonContainer.module.scss'
import PlayButton from './PlayButton'
import checkUrlType from '../../../../../utils/url-type-checker'
import { StorefrontItemPlaybackAction } from 'DVWebNodeUtils';

interface PlayButtonContainerProps {
  style?: React.CSSProperties
  playbackAction: StorefrontItemPlaybackAction
  onClick: Function
  linkRef: React.RefObject<HTMLAnchorElement>
  canLivePlayback: boolean
  isLive: boolean
  shouldFadeIn?: boolean
  children?: React.ReactChild | React.ReactChild[]
  playButtonClassName?: string
}

const PlayButtonContainer = (props: PlayButtonContainerProps) => (
  <div style={props.style}
    className={cn({
      'deeplinkable': Boolean(props.playbackAction),
    }, cardStyles.PlayButtonContainer, props.playButtonClassName)}>
    <a
      ref={props.linkRef}
      onClick={() => {
        // TODO(AVWebStorefront-2952): This is most likely legacy code that should be removed
        if (props.onClick) {
          props.onClick()
        }
      }}
      data-lcid={props.playbackAction && props.playbackAction.channelId}
      data-asin={props.playbackAction && props.playbackAction.titleID}
      data-ref-tag={props.playbackAction && props.playbackAction.refMarker}
      data-ref={props.playbackAction && props.playbackAction.refMarker}
      data-resume-time={props.playbackAction &&
        (props.playbackAction.resumeTime || '0')}
      href={checkUrlType(props.playbackAction &&
        (!props.isLive || props.canLivePlayback) &&
        props.playbackAction.fallbackUrl, 'PlayButtonContainer')}
      data-video-type={props.playbackAction &&
        props.playbackAction.videoMaterialType}
      data-session-id={props.playbackAction && props.playbackAction.sessionID}
      data-fallback-url={props.playbackAction && props.playbackAction.appFallbackUrl}
    >
      {props.children}
      <div
        className={cn('tst-playbutton', [styles.PlayButtonActionArea], { [styles.live]: props.isLive })}
      >
        <PlayButton
          wrapperStyle={styles.playButton}
          svgStyle={styles.svg}
          circleStyle={styles.circle}
          triangleStyle={styles.triangle} />
      </div>
    </a>
  </div>
)

export default PlayButtonContainer
